import { cn } from "@/lib/utils";

type NightCapBarProps = {
  used: number;
  cap: number;
  showLabel?: boolean;
};

export function NightCapBar({ used, cap, showLabel = false }: NightCapBarProps) {
  const percentage = cap > 0 ? Math.round((used / cap) * 100) : 0;
  const isOverLimit = used > cap;

  const barColor = isOverLimit
    ? "bg-red-500"
    : percentage >= 90
    ? "bg-red-500"
    : percentage >= 70
    ? "bg-amber-500"
    : "bg-green-500";

  const trackColor = isOverLimit
    ? "bg-red-100"
    : percentage >= 90
    ? "bg-red-100"
    : percentage >= 70
    ? "bg-amber-100"
    : "bg-green-100";

  const displayValue = Math.min(percentage, 100);

  return (
    <div className="w-full space-y-1">
      <div className={cn("relative h-2 w-full overflow-hidden rounded-full", trackColor)}>
        <div
          className={cn("h-full rounded-full transition-all", barColor)}
          style={{ width: `${displayValue}%` }}
        />
      </div>
      {showLabel && (
        <div className="flex items-center justify-between">
          <span className="text-xs text-gray-500">
            {used} / {cap} nights
          </span>
          {isOverLimit && (
            <span className="text-xs font-semibold text-red-600 uppercase tracking-wide">
              Over Limit
            </span>
          )}
        </div>
      )}
    </div>
  );
}
